import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { DialogService } from 'src/app/shared/components/dialog/dialog.service';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { SimulationStatus } from 'src/app/simulation/state/simulation.model';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { ProjectFormComponent } from '../project-form/project-form.component';
import { Project, ProjectUploadStatus } from '../state/project.model';
import { ProjectQuery } from '../state/project.query';
import { ProjectService } from '../state/project.service';

@Component({
  selector: 'app-project-menu',
  templateUrl: './project-menu.component.html',
  styleUrls: ['./project-menu.component.scss']
})
export class ProjectMenuComponent implements OnInit {

  uploadStatus$ = this.projectQuery.selectUploadStatus();
  project$ = this.projectQuery.selectActive();

  step = 0;
  stepChecked: number;
  resultMode: boolean;

  ProjectUploadStatus = ProjectUploadStatus;

  constructor(
    private projectService: ProjectService,
    private projectQuery: ProjectQuery,
    private simulationQuery: SimulationQuery,
    private windowService: WindowService,
    private snackBar: MatSnackBar,
    private dialogService: DialogService

  ) { }

  ngOnInit(): void {
    this.stepChecked = -1;
    this.project$.pipe(take(1))
      .subscribe(p => {
        if (p.validated) {
          this.stepChecked = 0;
          this.setStep(1);
        }
      });

    this.simulationQuery.active$.subscribe(s => {
      if (s) {
        this.setStep(1);
      }
    });

    this.simulationQuery.selectAll()
      .subscribe(simulations => {
        const i = simulations.findIndex(s => s.status && s.status !== SimulationStatus.DONE);
        if (simulations.length && i < 0) {
          this.stepChecked = 1;
        }
      });

    this.simulationQuery.select(['resultMode'])
      .subscribe(({ resultMode }) => this.resultMode = resultMode);
  }

  setStep(index: number) {
    this.step = index;
  }

  back() {
    this.projectService.revomeActive();
  }

  edit(project: Project) {
    const titleConfig = $localize`DESIGN EDITION`;
    this.windowService.open({
      componentType: ProjectFormComponent,
      title: titleConfig,
      help: 'ADD_PROJECT',
      config: {
        id: 'PROJECT_EDITION',
        data: project
      }
    });
  }

  remove(project: Project) {
    this.dialogService.confirm($localize`Do you really want to remove "${project.name}"?`)
      .subscribe(result => {

        if (result) {
          const titleSnackBar = $localize`Error on removing design`;
          const close = $localize`CLOSE`;
          this.projectService.remove(project.id)
            .pipe(
              catchError(error => {
                this.snackBar.open(titleSnackBar, close);
                return throwError(error);
              })
            )
            .subscribe();
        }
      });
  }

}
